import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { AccordionDetails, Button, Checkbox, Grid, IconButton, Paper, Stack } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import ProgressBar from 'src/components/common/ProgressBar';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { archLevel } from 'src/data/config';
import { setMessage } from 'src/store/Message';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import './SiteDocuments.scss';
import { useEssentialDocs } from './useEssentialDocs';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const SiteDocuments: React.FunctionComponent<any> = ({ DocNameData, DocSecData }) => {
  const { siteDocuments } = useFieldTranslation();
  const [expanded, setExpanded] = React.useState<string | false>('panel1');
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };
  const { sdpDataUpdateSuccessMsg, sdpErrorMsg } = useFieldTranslation();

  const [siteDocs, setSiteDocs] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [updatingObj, setUpdatingObj] = useState<any>([]);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_essential_Documents');
  const { user } = useUser();
  const { essentialDocsQueryData, getEssentialDocsQueryData, updateEssentialDocs } = useEssentialDocs();

  useEffect(() => {
    if (essentialDocsQueryData) {
      setSiteDocs(essentialDocsQueryData);
    }
  }, [essentialDocsQueryData]);

  // const getSiteDocumentList = async () => {
  //   try {
  //     setIsLoading(true);
  //     const options = {
  //       study_id: studyId,
  //       site_id: selectedSite,
  //       pathVariables: {
  //         country: selectedCountry,
  //         appName: process.env.REACT_APP_NAME
  //       }
  //     };
  //     const response = await sendRequest('get_essential_docs_by_siteid_studyid', options);
  //     setSiteDocs(response);
  //     setIsLoading(false);
  //   } catch (error: any) {
  //     setIsLoading(false);
  //     //store.dispatch(setSnackbarMessage('Request Failed', 'error'));
  //     if (error.response.status === 403) {
  //       dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
  //     } else if (error.response.status === 401) {
  //       dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
  //     }
  //   }
  // };

  useEffect(() => {
    //getSiteDocumentList();
    getEssentialDocsQueryData();
  }, [selectedSite]);

  const handleChangeCheckbox = (e: any, id: any) => {
    const newSiteDocs = [];
    const editedDocs = [];
    const ids: any = [];
    let oldUpdatingObjs = [];
    for (const siteDoc of siteDocs) {
      if (siteDoc.essential_document_id == id) {
        oldUpdatingObjs = updatingObj.map((obj: any) => {
          ids.push(obj.id);
          if (obj.id == id) {
            if (e.target.checked == true) {
              return { ...obj, [e.target.name]: 'Y' };
            } else {
              return { ...obj, [e.target.name]: 'N' };
            }
          } else {
            return obj;
          }
        });
        if (!ids.includes(siteDoc.essential_document_id)) {
          const obj = {
            id: siteDoc.essential_document_id,
            sponsor_document: siteDoc.sponsor_document,
            site_document: siteDoc.site_document,
            sponsor_document_status: siteDoc.sponsor_document_status,
            site_document_status: siteDoc.site_document_status
          };
          if (e.target.checked == true) {
            editedDocs.push({ ...obj, [e.target.name]: 'Y' });
          } else {
            editedDocs.push({ ...obj, [e.target.name]: 'N' });
          }
        }
        if (e.target.checked == true) {
          newSiteDocs.push({ ...siteDoc, [e.target.name]: 'Y' });
        } else {
          newSiteDocs.push({ ...siteDoc, [e.target.name]: 'N' });
        }
      } else {
        newSiteDocs.push(siteDoc);
      }
      setUpdatingObj([...oldUpdatingObjs, ...editedDocs]);
      setSiteDocs(newSiteDocs);
      setConfirmExitValue(dispatch, true);
    }
  };

  const handleSaveBtn = async () => {
    try {
      if (updatingObj.length > 0) {
        const resObj = {
          Essential_Document_update: updatingObj,
          updated_by: user
        };
        // const options = {
        //   study_id: studyId,
        //   site_id: selectedSite,
        //   data: resObj,
        //   pathVariables: {
        //     country: selectedCountry,
        //     appName: process.env.REACT_APP_NAME
        //   }
        // };
        setIsLoading(true);
        // const response: any = await sendRequest('update_essential_docs_by_siteid_studyid', options);
        await updateEssentialDocs({
          study_id: studyId,
          site_id: selectedSite,
          data: resObj,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
        getEssentialDocsQueryData();
        setIsLoading(false);
        setIsLoading(false);
        setUpdatingObj([]);
        // store.dispatch(setSnackbarMessage('Essential Documents updated successfully.', 'success'));
        dispatchApp(setMessage({ msgDetails: sdpDataUpdateSuccessMsg, severity: 'success' }));

        setConfirmExitValue(dispatch, false);
      }
    } catch (error) {
      setIsLoading(false);

      // store.dispatch(setSnackbarMessage('Error in updating Essential Documents', 'error'));
      dispatchApp(setMessage({ msgDetails: sdpErrorMsg, severity: 'error' }));
    }
  };

  function Row(props: { row: any; siteDocs: any }) {
    const { row, siteDocs } = props;
    const [open, setOpen] = React.useState(true);
    const itemRows = [];

    for (const doc of siteDocs) {
      if (row.code_list_value_code == doc.document_name_site_docs_value_code) {
        const codelist = DocSecData?.filter((item: any) => {
          if (item.code_list_value_code === doc.document_section_name_site_docs_value_code) {
            return item;
          }
        });

        const row = (
          <TableRow>
            <TableCell>{codelist[0].code_list_value}</TableCell>
            <TableCell>
              <Checkbox
                {...label}
                name="sponsor_document"
                onClick={e => handleChangeCheckbox(e, doc.essential_document_id)}
                checked={doc.sponsor_document == 'Y' ? true : false}
                disabled={archLevel == 'site' || !isDisable}
              />
              {doc.sponsor_document == 'Y' && <label className="progress-label">{doc.sponsor_document_status}</label>}
            </TableCell>
            <TableCell>
              <Checkbox
                {...label}
                name="site_document"
                onClick={e => handleChangeCheckbox(e, doc.essential_document_id)}
                checked={doc.site_document == 'Y' ? true : false}
                disabled={archLevel == 'site' || !isDisable}
              />
              {doc.site_document == 'Y' && <label className="progress-label">{doc.site_document_status}</label>}
            </TableCell>
          </TableRow>
        );

        itemRows.push(row);
        //setList({ ...row, ...DocSecData });
      }
    }

    return (
      <>
        <TableRow
          sx={{ '& > *': { borderBottom: 'unset' } }}
          className="category-table"
          onClick={() => {
            setOpen(!open);
          }}
        >
          <TableCell component="th" scope="row" colSpan={2}>
            {row.code_list_value}
          </TableCell>
          <TableCell align="right">
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableBody>{itemRows}</TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <div className="pi-accordion site-documents">
      {isLoading && <ProgressBar />}
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>Site Documents</Typography>
        </AccordionSummary>
        <AccordionDetails className="accordion-body">
          <Grid container>
            <Grid md={12}>
              <p>{siteDocuments.header1}:</p>
              <Typography>
                <TableContainer component={Paper} className="sitedocuments-table">
                  <Table stickyHeader aria-label="collapsible table">
                    <TableHead>
                      <TableRow>
                        <TableCell>{siteDocuments.label1}</TableCell>
                        <TableCell>{siteDocuments.label2}</TableCell>
                        <TableCell>{siteDocuments.label3}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {DocNameData && DocNameData.map((row: any) => <Row key={row.id} row={row} siteDocs={siteDocs} />)}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Typography>
            </Grid>
          </Grid>
        </AccordionDetails>
        <Grid container className="fixed-buttons-block">
          <Grid md={12} display="flex" justifyContent="flex-end">
            <Stack spacing={2} direction="row">
              {checkPermission('update_essential_Documents') && archLevel == 'sponsor' ? (
                <Button onClick={handleSaveBtn} variant="text">
                  SAVE
                </Button>
              ) : null}
            </Stack>
          </Grid>
        </Grid>
      </Accordion>
    </div>
  );
};

export default SiteDocuments;
